export const updateFilePermissionsBulkActionType = 'updateFilePermissions';
